export function isEmpty(obj): boolean {
    return Object.keys(obj).length === 0
}

export function buildValue(value, events = []): string {
    const values = (value.match(/\#\{(\w+)\}/g) || []).map(e => e.substr(2, e.length - 3))

    let newValue = value

    Array.prototype.forEach.call(events, e => {
        Array.prototype.forEach.call(values, v => {
            if (e[v]) {
                newValue = newValue.replace(`#{${v}}`, e[v])
            }
        })
    })

    return newValue
}

export function makeDecimal(value, target): number {
    const num = parseInt(value)

    const decimal = num / target
    return decimal
}
